const my_profile = {
  viewMyClubSeacretProfile: "عرض ملفي الشخصي في ClubSeacret", // translated
  viewMoreDetails: "عرض المزيد من التفاصيل", // translated
  verifiedEmail: "بريد إلكتروني تم التحقق منه", // translated
  unverifiedEmail: "البريد الإلكتروني لم يتم التحقق منها", // translated
  balance: "توازن", // translated
  pointsIn: "النقاط في", // translated
  pointsOut: "يشير الى", // translated
  topUp: "فوق حتى", // translated
  pointsHistoryTable: "جدول تاريخ النقاط", // translated
  createdFrom: "تم الإنشاء من", // translated
  createdTo: "تم الإنشاء إلى", // translated
  selectStatus: "اختر الحالة...", // translated
  searchByTitle: "البحث حسب العنوان...", // translated
};

export default my_profile;
